/**
 * NoResults
 *
 * Empty state for template grids with optional clear-filters CTA.
 */
import React from 'react';

const NoResults = ({ clearFilters }) => {
  return (
    <div className="flex flex-col items-center justify-center py-12 px-4 text-center">
      <svg 
        className="w-16 h-16 text-gray-400 mb-4" 
        fill="none" 
        stroke="currentColor" 
        viewBox="0 0 24 24" 
        xmlns="http://www.w3.org/2000/svg"
      >
        <path 
          strokeLinecap="round" 
          strokeLinejoin="round" 
          strokeWidth="2" 
          d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
        />
      </svg>
      <h3 className="text-xl font-semibold text-gray-900 dark:text-gray-100 mb-2">No Templates Found</h3>
      <p className="text-gray-600 dark:text-gray-400 mb-6 max-w-md">
        We couldn't find any templates matching your current filters or search query.
      </p>
      {clearFilters && (
        <button
          onClick={clearFilters}
          className="px-4 py-2 bg-primary-600 text-white rounded-md hover:bg-primary-700 transition-colors"
        >
          Clear Filters
        </button>
      )}
    </div>
  );
};

export default NoResults; 